import React, { Component } from 'react'
import { Form, DatePicker, Input, Button, Popconfirm, message } from 'antd'
import moment from 'moment'
import { validateDate } from '../util'
const FormItem = Form.Item
const propTypes = {}

class ScheduleApplicationDatesView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      currentDates: {},
      contentData: null
    }
  }

  componentDidMount() {
    this.setState({
      currentDates: this.props.data
    })
  }

  componentWillUnmount() {
    this.props.clearHighlight()
  }

  handleSaveDatesClick = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      let transformedDates = {}
      let scheduleType = null
      let scheduleDescription = null
      const currentDates = this.state.currentDates
      Object.keys(values).forEach(function(key, value) {
        if (values[key] !== null) {
          if (moment.isMoment(values[key])) {
            if (!moment(values[key]).isSame(currentDates[key])) {
              scheduleType = key
              scheduleDescription = values['notes']
            }
          }
        }
        if (key !== 'description') transformedDates[key] = validateDate(values[key])
      })

      this.props.updateApplicationDates({
        jobId: this.props.jobId,
        scheduleId: this.props.machineIndex,
        userId: this.props.userId,
        content: transformedDates,
        scheduleType: scheduleType,
        description: scheduleDescription
      })

      form.resetFields()
      this.props.clearFields()
    })
    this.setState({
      isEditing: false
    })
  }

  handleNotesBlur = e => {
    this.props.updateNotes({
      jobId: this.props.jobId,
      scheduleId: this.props.machineIndex,
      userId: this.props.userId,
      notes: e.target.value
    })
    message.success('Notes saved.')
  }

  handleCancelEditClick = () => {
    this.props.clearFields()
  }

  cancelDelete = () => {
    this.props.clearFields()
  }

  confirmDelete = () => {
    this.props.deleteSchedule(this.props.machineIndex)
  }

  confirmDeleteNote = noteId => {
    const form = this.props.form
    this.props.deleteNote({
      jobId: this.props.jobId,
      noteId: noteId
    })
    form.resetFields()
    message.success('Note deleted.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createNote({
          jobId: this.props.jobId,
          content: values.description,
          userId: this.props.userId
        })
      } else {
        this.props.updateNote({
          jobId: this.props.jobId,
          noteId: this.state.currentId,
          files: values.files,
          content: values.description,
          userId: this.props.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { data, isEditing, scheduleApplicationType } = this.props
    return (
      <div>
        <Form layout="vertical">
          <div className="row sceduleTitleRow">
            <div className="col-md-9">
              {!isEditing && <h2>{data.name}</h2>}
              {isEditing && (
                <div>
                  <FormItem>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'Schedule device must have a name.'
                        }
                      ],
                      initialValue: data.name
                    })(<Input />)}
                  </FormItem>
                </div>
              )}
            </div>
            <div className="col-md-3">
              {isEditing && (
                <div className="datesButtonArea">
                  <Button type="primary" icon="save" onClick={() => this.handleSaveDatesClick()} />
                  <Button
                    type="default"
                    icon="close"
                    className="marginRight10"
                    onClick={() => this.handleCancelEditClick()}
                  />
                </div>
              )}
            </div>
          </div>
          {data && (
            <div>
              <div className="row padding20">
                <div className="col-xs-12 col-md-4">
                  <div
                    className={
                      scheduleApplicationType === 'requested_bec_date'
                        ? 'dateBlock flashit'
                        : 'dateBlock'
                    }
                  >
                    <div className="jobDetailsHeader">Requested BEC</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('requested_bec_date', {
                          initialValue: moment(data.requested_bec_date).isValid()
                            ? moment.utc(data.requested_bec_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.requested_bec_date !== null
                          ? moment.utc(data.requested_bec_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      scheduleApplicationType === 'requested_elevator_application_date'
                        ? 'dateBlock flashit'
                        : 'dateBlock'
                    }
                  >
                    <div className="jobDetailsHeader">Requested Elevator Application</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('requested_elevator_application_date', {
                          initialValue: moment(data.requested_elevator_application_date).isValid()
                            ? moment.utc(data.requested_elevator_application_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.requested_elevator_application_date !== null
                          ? moment.utc(data.requested_elevator_application_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">
                      Requested Temporary Construction Use Amendment
                    </div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('requested_temporary_construction_use_amendment_date', {
                          initialValue: moment(
                            data.requested_temporary_construction_use_amendment_date
                          ).isValid()
                            ? moment.utc(data.requested_temporary_construction_use_amendment_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.requested_temporary_construction_use_amendment_date !== null
                          ? moment
                              .utc(data.requested_temporary_construction_use_amendment_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Temporary Construction Use Inspection</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('temporary_construction_use_inspection_date', {
                          initialValue: moment(
                            data.temporary_construction_use_inspection_date
                          ).isValid()
                            ? moment.utc(data.temporary_construction_use_inspection_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.temporary_construction_use_inspection_date !== null
                          ? moment
                              .utc(data.temporary_construction_use_inspection_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Final Inspection Request</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('final_inspection_request_date', {
                          initialValue: moment(data.final_inspection_request_date).isValid()
                            ? moment.utc(data.final_inspection_request_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.final_inspection_request_date !== null
                          ? moment.utc(data.final_inspection_request_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">BEC Inspection Request</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('bec_inspection_request_date', {
                          initialValue: moment(data.bec_inspection_request_date).isValid()
                            ? moment.utc(data.bec_inspection_request_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.bec_inspection_request_date !== null
                          ? moment.utc(data.bec_inspection_request_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Received BEC</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('received_bec_date', {
                          initialValue: moment(data.received_bec_date).isValid()
                            ? moment.utc(data.received_bec_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.received_bec_date !== null
                          ? moment.utc(data.received_bec_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Received Elevator Application</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('received_elevator_application_date', {
                          initialValue: moment(data.received_elevator_application_date).isValid()
                            ? moment.utc(data.received_elevator_application_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.received_elevator_application_date !== null
                          ? moment(data.received_elevator_application_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">
                      Received Temporary Construction Use Amendment
                    </div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('received_temporary_construction_use_amendment_date', {
                          initialValue: moment(
                            data.received_temporary_construction_use_amendment_date
                          ).isValid()
                            ? moment.utc(data.received_temporary_construction_use_amendment_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.received_temporary_construction_use_amendment_date !== null
                          ? moment
                              .utc(data.received_temporary_construction_use_amendment_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">
                      Temporary Construction Use Inspection Expiration
                    </div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator(
                          'temporary_construction_use_inspection_expiration_date',
                          {
                            initialValue: moment(
                              data.temporary_construction_use_inspection_expiration_date
                            ).isValid()
                              ? moment.utc(
                                  data.temporary_construction_use_inspection_expiration_date
                                )
                              : null
                          }
                        )(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.temporary_construction_use_inspection_expiration_date !== null
                          ? moment
                              .utc(data.temporary_construction_use_inspection_expiration_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Final Inspection</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('final_inspection_date', {
                          initialValue: moment(data.final_inspection_date).isValid()
                            ? moment.utc(data.final_inspection_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.final_inspection_date !== null
                          ? moment.utc(data.final_inspection_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">BEC Inspection</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('bec_inspection_date', {
                          initialValue: moment(data.bec_inspection_date).isValid()
                            ? moment.utc(data.bec_inspection_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.bec_inspection_date !== null
                          ? moment.utc(data.bec_inspection_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">BEC Permit Expiration</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('bec_permit_expiration_date', {
                          initialValue: moment(data.bec_permit_expiration_date).isValid()
                            ? moment.utc(data.bec_permit_expiration_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.bec_permit_expiration_date !== null
                          ? moment.utc(data.bec_permit_expiration_date).format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">Elevator Application Expiration</div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('elevator_application_expiration_date', {
                          initialValue: moment(data.elevator_application_expiration_date).isValid()
                            ? moment.utc(data.elevator_application_expiration_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.elevator_application_expiration_date !== null
                          ? moment
                              .utc(data.elevator_application_expiration_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                  <div className="dateBlock">
                    <div className="jobDetailsHeader">
                      Temporary Construction Use Inspection Request
                    </div>
                    {isEditing && (
                      <FormItem>
                        {getFieldDecorator('temporary_construction_use_inspection_request_date', {
                          initialValue: moment(
                            data.temporary_construction_use_inspection_request_date
                          ).isValid()
                            ? moment.utc(data.temporary_construction_use_inspection_request_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!isEditing && (
                      <div>
                        {data.temporary_construction_use_inspection_request_date !== null
                          ? moment
                              .utc(data.temporary_construction_use_inspection_request_date)
                              .format('MM/D/YYYY')
                          : 'Not Entered'}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <Popconfirm
                    title="Are you sure you want to delete this schedule?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="marginRight20" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

ScheduleApplicationDatesView.propTypes = propTypes
export default Form.create()(ScheduleApplicationDatesView)



// WEBPACK FOOTER //
// ./src/components/ScheduleApplicationDatesView.js